// current tripadvancePaymentTable
import { TableBody, TableCell, TableRow } from "@windmill/react-ui";

import { FaInfoCircle } from "react-icons/fa";
import DeleteModal from "components/modal/DeleteModal";
import Tooltip from "@mui/material/Tooltip";
import ItineraryModal from "components/form/ItineraryModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import React, { useState, useContext } from "react";
import { SidebarContext } from "context/SidebarContext";
import TripadvanceApprovalServices from "services/TripadvanceApprovalServices";
import TripadvancePayment from "components/modal/TripadvancePaymentModal";
import TripadvanceReadyPayment from "components/modal/TripAdvanceReadyPaymentModal";
import { notifySuccess } from "utils/toast";
import TripadvancePaymentServices from "services/TripadvancePaymentServices";

const TripadvancePaymentTable = ({
  tripadvancepayment,
  perpage,
  currentPage,
  tab,
  hideEdit,
}) => {
  const { title, serviceId, handleView } = useToggleDrawer();

  const [showItineraryModal, setShowItineraryModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [tripadvance, setTripadvance] = useState(false);
  const [error, setError] = useState("");
  const [selectedData, setSelectedData] = useState(null);
  const [adjustData, setAdjustData] = useState([]);
  const [, setIsRemarkModalOpen] = useState(false);
  const [itinerary] = useState("");
  const [open, setOpen] = useState(false);
  const [allData, setAllData] = useState([]);
  const [clientId, setClientID] = useState(0);
  const [finalAmt, setFinalAmt] = useState("");

  const { setIsUpdate } = useContext(SidebarContext);

  const handleOpen = (data) => {
    setAllData(data);
    setOpen(true);
  };

  const handleClick = async (data, i) => {
    try {
      const response = await TripadvanceApprovalServices.checkoutstanding(
        data.vendor_id,
      );

      if (response?.status) {
        setAdjustData(response.data);
      } else {
        setError("Failed to fetch Trip Advance data .");
      }
    } catch (error) {
      console.error("API Error:", error);
      setError("An error occurred while fetching Trip Advance data .");
    }

    const request = data.requests[i];

    setClientID(data.id_client);
    setSelectedData(request.id);

    const nextPayable = Number(request.trip_advance_request);

    setTripadvance(nextPayable > 0 ? nextPayable : 0);
    setFinalAmt(request.trip_advance_amount);
    setShowModal(true);
  };

  const closeModal = () => {
    setIsRemarkModalOpen(false);
    setShowModal(false);
    setOpen(false);
  };

  const handleSubmit = async (data) => {
    const paymentPayload = {
      paid_date: data.paid_date,
      payment_type: data.payment_type,
      remark: data.remark,
      utr: data.utr,
      trip_advance_paid: Number(data.payable_amount),
      va_ids: data.va_ids,
    };

    try {
      const response =
        await TripadvancePaymentServices.updatetripadvancepayment(
          selectedData,
          paymentPayload,
        );

      if (response?.status) {
        notifySuccess(response.message);
        setIsUpdate(true);
        closeModal();
      } else {
        setError("Failed to submit the trip advance request.");
      }
    } catch (error) {
      console.error("API Error:", error);
      setError("An error occurred while submitting the trip advance request.");
    }
  };

  const handleSubmitReady = async (data) => {
    const payload = {
      paid_date: data.paid_date,
      payment_type: data.payment_type,
      remark: data.remark,
      utr: data.utr,
      trip_advance_paid: {
        id: data?.trip_advance_paid?.id?.map(Number) || [],
      },
    };

    try {
      const response =
        await TripadvancePaymentServices.updatetripadvanceReadypayment(payload);

      if (response?.status) {
        notifySuccess(response.message);
        setIsUpdate(true);
        closeModal();
      } else {
        setError("Failed to submit the trip advance request.");
      }
    } catch (error) {
      console.error("API Error:", error);
      setError("An error occurred while submitting the trip advance request.");
    }
  };

  const groupedArray = tripadvancepayment;

  const isTripCompleted = (endDate) => {
    if (!endDate) return false;

    const dateStr = Array.isArray(endDate) ? endDate[0] : endDate;

    if (!dateStr) return false;

    const [dd, mm, yyyy] = dateStr.split("-");

    const tripEnd = new Date(`${yyyy}-${mm}-${dd}`);
    const today = new Date();

    tripEnd.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return today > tripEnd;
  };

  const getEndDate = (data, i = 0) =>
    Array.isArray(data.end_date) ? data.end_date[i] : data.end_date;

  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <TripadvancePayment
        title="Make Payment"
        isOpen={showModal}
        finalAmt={finalAmt}
        onClose={() => setShowModal(false)}
        handleSubmit={handleSubmit}
        tripAdvanceAmt={tripadvance}
        data={adjustData}
      />

      <TripadvanceReadyPayment
        title="Make Bulk Payment"
        isOpen={open}
        onClose={() => setOpen(false)}
        handleSubmitReady={handleSubmitReady}
        data={allData}
      />

      <ItineraryModal
        isOpen={showItineraryModal}
        content={itinerary}
        onClose={() => setShowItineraryModal(false)}
      />

      <TableBody>
        {tab !== 1 &&
          groupedArray.slice(0, perpage).map((data, index) => (
            <TableRow
              key={data.id || index}
              className={
                data.booking_status === 1 ? "bg-red-100 dark:bg-gray-500" : ""
              }
            >
              <TableCell className="text-center text-sm">
                {(currentPage - 1) * perpage + index + 1}
              </TableCell>

              <TableCell className="text-center text-sm">
                {data.ref_no}
              </TableCell>

              <TableCell className="text-center text-sm">
                {data.client_name}
              </TableCell>

              <TableCell>
                <div className="flex flex-col row-gap-4 text-sm items-center">
                  <p className="m-0">{data.start_date}</p>
                  <p className="m-0">{data.end_date}</p>
                </div>
              </TableCell>

              <TableCell>
                <div className="flex flex-col row-gap-4 text-sm items-center">
                  <p className="m-0">{data.arrival}</p>
                  <p className="m-0">{data.departure}</p>
                </div>
              </TableCell>

              <TableCell className="text-sm text-center">
                {data.no_of_days}
              </TableCell>

              <TableCell className="text-sm text-center">
                {data.vendor_name}
              </TableCell>

              <TableCell
                colSpan={4}
                className="p-0 align-middle"
                style={{
                  minWidth: "520px",
                  width: "520px",
                }}
              >
                <div
                  className="w-full"
                  style={{
                    minWidth: "520px",
                  }}
                >
                  {data.requests?.map((request, i) => {
                    const totalPaid = Number(request.amount_paid) || 0;

                    const payments = Array.isArray(request.payment_history)
                      ? request.payment_history
                      : [];

                    const totalRequested =
                      Number(request.amount_requested) || 0;

                    const payable = Math.max(0, totalRequested - totalPaid);

                    // KEEP renderPaymentTooltip HERE.
                    // Do not move or separate this function.
                    const renderPaymentTooltip = (payment, key) => (
                      <div className="text-sm space-y-2">
                        {Number(payment.adjusted_amount) > 0 && (
                          <div className="pb-2 border-b border-gray-400">
                            <div>
                              <strong className="text-yellow-300">
                                Adjustment Applied: ₹{payment.adjusted_amount}
                              </strong>
                            </div>

                            <div className="text-sm text-gray-300 mt-1">
                              From Outstanding Credits:
                            </div>

                            {(payment.adjustments || []).map((adj, adjIdx) => (
                              <div
                                key={`adj-${key}-${adjIdx}`}
                                className="text-sm text-gray-200 ml-2 mt-1"
                              >
                                ₹{adj.adjusted_amount} from{" "}
                                {adj.ref_no || "booking"}
                              </div>
                            ))}
                          </div>
                        )}

                        {Number(payment.amount) > 0 && (
                          <div>
                            <div>
                              <strong
                                className={
                                  Number(payment.adjusted_amount) > 0
                                    ? "text-green-300"
                                    : ""
                                }
                              >
                                {Number(payment.adjusted_amount) > 0
                                  ? "Cash Payment:"
                                  : "Payment Details:"}
                              </strong>
                            </div>

                            <div className="mt-1">
                              Amount: <strong>₹{payment.amount}</strong>
                            </div>

                            <div>
                              Date:{" "}
                              {new Date(payment.paid_date).toLocaleDateString(
                                "en-GB",
                              )}
                            </div>

                            <div>Type: {payment.payment_type}</div>

                            {payment.utr && <div>UTR: {payment.utr}</div>}
                          </div>
                        )}

                        {Number(payment.adjusted_amount) > 0 && (
                          <div className="pt-2 border-t border-gray-400 font-semibold text-blue-300">
                            Total Payment: ₹
                            {Number(payment.adjusted_amount) +
                              Number(payment.amount)}
                          </div>
                        )}
                      </div>
                    );

                    const notPayableReason = request.not_payable_reason;

                    return (
                      <div
                        key={`request-row-${i}`}
                        className={`grid w-full ${
                          i < data.requests.length - 1
                            ? "border-b border-gray-100"
                            : ""
                        }`}
                        style={{
                          gridTemplateColumns: "150px 140px 140px 170px",
                          minWidth: "620px",
                        }}
                      >
                        <div className="flex items-center justify-center text-center text-sm py-2 font-semibold text-gray-700 whitespace-nowrap">
                          ₹{totalRequested}
                        </div>

                        <div className="flex flex-col items-center justify-center text-center text-sm py-2 text-green-700 min-w-0">
                          {payments?.length === 0 ? (
                            tab === 2 && totalPaid > 0 ? (
                              <span className="whitespace-nowrap">
                                ₹{totalPaid}
                              </span>
                            ) : (
                              <span className="text-gray-400 text-sm">-</span>
                            )
                          ) : (
                            <div className="flex flex-col items-center justify-center gap-1 w-full">
                              {payments.map((payment, idx) => {
                                const paidAmount =
                                  Number(payment.amount) +
                                  Number(payment.adjusted_amount || 0);

                                return (
                                  <div
                                    key={`payment-row-${idx}`}
                                    className="flex items-center justify-center gap-1 py-1 whitespace-nowrap w-full"
                                  >
                                    <span>₹{paidAmount}</span>

                                    <Tooltip
                                      title={renderPaymentTooltip(payment, idx)}
                                      arrow
                                    >
                                      <span className="inline-flex items-center flex-shrink-0">
                                        <FaInfoCircle
                                          className="text-blue-500 cursor-pointer"
                                          style={{
                                            fontSize: 13,
                                          }}
                                        />
                                      </span>
                                    </Tooltip>

                                    {/* Existing commented content kept unchanged */}
                                    {/* <span className="text-sm text-gray-500">
                          {new Date(
                            payment.paid_date
                          ).toLocaleDateString(
                            "en-GB"
                          )}

                          {payment.adjusted_amount >
                          0
                            ? " · Adjustment"
                            : payment.payment_type
                            ? ` · ${payment.payment_type}`
                            : ""}
                        </span> */}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>

                        {/* =========================
              PAYABLE
          ========================== */}
                        <div
                          className={`flex items-center justify-center text-center text-sm py-2 font-semibold whitespace-nowrap ${
                            payable <= 0 ? "text-green-600" : "text-red-600"
                          }`}
                        >
                          ₹{payable}
                        </div>

                        {/* =========================
              ACTION
          ========================== */}
                        <div className="flex items-center justify-center text-center py-2 min-w-0">
                          {notPayableReason === "PAID" ? (
                            <div key={`request-${i}`}>
                              <Tooltip
                                title={
                                  <div>
                                    <div className="mb-2">
                                      <strong>Date:</strong>{" "}
                                      {request.paid_date || "N/A"}
                                    </div>

                                    <div className="mb-2">
                                      <strong>Type:</strong>{" "}
                                      {request.payment_type || "N/A"}
                                    </div>

                                    <div className="mb-2">
                                      <strong>UTR:</strong>{" "}
                                      {request.utr || "N/A"}
                                    </div>

                                    <div className="mb-2">
                                      <strong>Remarks:</strong>{" "}
                                      {request.paid_remark || "N/A"}
                                    </div>
                                  </div>
                                }
                                placement="top-start"
                                arrow
                              >
                                <span className="text-green-600 cursor-pointer text-sm whitespace-nowrap">
                                  PAID
                                </span>
                              </Tooltip>
                            </div>
                          ) : notPayableReason ? (
                            <div key={`action-${i}`}>
                              <span className="text-red-500 font-semibold text-sm whitespace-nowrap">
                                {notPayableReason}
                              </span>
                            </div>
                          ) : (
                            <div key={`action-${i}`}>
                              {hideEdit ? (
                                <button
                                  className="ml-2 px-2 py-1 text-sm text-white bg-yellow-500 rounded hover:bg-yellow-600 whitespace-nowrap"
                                  onClick={() => handleClick(data, i)}
                                >
                                  Pay
                                </button>
                              ) : (
                                <span className="text-red-500 font-semibold text-sm whitespace-nowrap">
                                  Yet to Pay
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </TableCell>
            </TableRow>
          ))}

        {tab === 1 &&
          groupedArray.slice(0, perpage).map((data, index) => (
            <TableRow key={data.id || index}>
              <TableCell className="text-center text-sm">
                <div className="mb-4 pb-2" key={index}>
                  {(currentPage - 1) * perpage + index + 1}
                </div>
              </TableCell>

              <TableCell className="text-center text-sm">
                <div className="mb-4 pb-2">{data.vendor_name}</div>
              </TableCell>

              <TableCell className="text-sm text-center">
                {data.bookings?.map((booking, i) => (
                  <div className="mb-4 pb-2" key={`ref-${i}`}>
                    {booking.ref_no}
                  </div>
                ))}
              </TableCell>

              <TableCell className="text-center text-sm">
                {data.bookings?.map((booking, i) => (
                  <div className="mb-4 pb-2" key={`name-${i}`}>
                    {booking.client_name}
                  </div>
                ))}
              </TableCell>

              <TableCell>
                {data.bookings?.map((booking, i) => (
                  <div
                    className="mb-4 pb-2 flex flex-col row-gap-4 text-sm items-center"
                    key={`date-${i}`}
                  >
                    <p className="m-0">{booking.start_date}</p>
                    <p className="m-0">{booking.end_date}</p>
                  </div>
                ))}
              </TableCell>

              <TableCell>
                {data.bookings?.map((booking, i) => (
                  <div
                    className="mb-4 pb-2 flex flex-col row-gap-4 text-sm items-center"
                    key={`date-${i}`}
                  >
                    <p className="m-0">{booking.arrival}</p>
                    <p className="m-0">{booking.departure}</p>
                  </div>
                ))}
              </TableCell>

              <TableCell className="text-sm text-center">
                {data.bookings?.map((booking, i) => (
                  <div className="mb-4 pb-2" key={`no_of_days-${i}`}>
                    {booking.no_of_days}
                  </div>
                ))}
              </TableCell>

              {/* Ready To Pay - Requested */}
              <TableCell className="text-center text-sm">
                {data.bookings?.map((booking, i) => {
                  const isTripNotWent = booking.trip_went_or_not === "2";

                  const totalRequested =
                    Number(
                      booking.amount_requested ?? booking.trip_advance_request,
                    ) || 0;

                  return (
                    <div
                      key={`requested-${i}`}
                      title={isTripNotWent ? "Trip not went" : ""}
                      className={`flex items-center justify-center py-1 font-semibold ${
                        isTripNotWent ? "text-red-600" : "text-gray-700"
                      } ${
                        data.bookings?.length > 1
                          ? "border-b border-gray-100"
                          : ""
                      }`}
                    >
                      ₹{totalRequested}
                    </div>
                  );
                })}
              </TableCell>

              {/* Ready To Pay - Paid */}
              <TableCell className="text-center text-sm">
                {data.bookings?.map((booking, i) => {
                  const totalPaid = Number(booking.amount_paid) || 0;

                  return (
                    <div
                      key={`paid-${i}`}
                      className={`flex items-center justify-center py-1 text-green-700 ${
                        data.bookings?.length > 1
                          ? "border-b border-gray-100"
                          : ""
                      }`}
                    >
                      {totalPaid > 0 ? (
                        `₹${totalPaid}`
                      ) : (
                        <span className="text-gray-400 text-sm">-</span>
                      )}
                    </div>
                  );
                })}
              </TableCell>

              {/* Ready To Pay - Payable */}
              <TableCell className="text-center text-sm">
                {data.bookings?.map((booking, i) => {
                  const totalRequested =
                    Number(
                      booking.amount_requested ?? booking.trip_advance_request,
                    ) || 0;

                  const totalPaid = Number(booking.amount_paid) || 0;

                  const payable = Math.max(0, totalRequested - totalPaid);

                  return (
                    <div
                      key={`payable-${i}`}
                      className={`flex items-center justify-center py-1 font-semibold ${
                        payable <= 0 ? "text-green-600" : "text-red-600"
                      } ${
                        data.bookings?.length > 1
                          ? "border-b border-gray-100"
                          : ""
                      }`}
                    >
                      ₹{payable}
                    </div>
                  );
                })}
              </TableCell>

              {/* Ready To Pay - Action */}
              <TableCell className="text-center">
                <div className="flex items-center justify-center" key="action">
                  {(() => {
                    const payableBookings = data?.bookings?.filter(
                      (b) => !b.not_payable_reason,
                    );

                    if (payableBookings?.length === 0) {
                      return (
                        <span className="text-red-500 font-semibold text-sm">
                          {data.bookings[0]?.not_payable_reason ||
                            "Not Payable"}
                        </span>
                      );
                    }

                    if (!hideEdit) {
                      return (
                        <span className="text-red-500 font-semibold text-sm">
                          Yet to Pay
                        </span>
                      );
                    }

                    const payableData = {
                      ...data,
                      bookings: payableBookings,
                    };

                    return (
                      <button
                        className="ml-2 px-2 py-1 text-sm text-white bg-yellow-500 rounded hover:bg-yellow-600"
                        onClick={() => handleOpen(payableData)}
                      >
                        Pay
                      </button>
                    );
                  })()}
                </div>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </>
  );
};

export default TripadvancePaymentTable;
